import { useRef, useEffect } from "react";
import { Bold, Italic, Heading2, Heading3, List, ListOrdered, Quote, Link2, Undo, Redo } from "lucide-react";

export default function RichEditor({ value, onChange }) {
  const ref = useRef();

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line
  }, []);

  const exec = (cmd, arg) => {
    document.execCommand(cmd, false, arg);
    ref.current?.focus();
    onChange(ref.current.innerHTML);
  };

  const link = () => {
    const url = window.prompt("লিংক URL দিন:");
    if (url) exec("createLink", url);
  };

  const btns = [
    { icon: Bold, cmd: () => exec("bold"), title: "বোল্ড" },
    { icon: Italic, cmd: () => exec("italic"), title: "ইটালিক" },
    { icon: Heading2, cmd: () => exec("formatBlock", "H2"), title: "শিরোনাম ২" },
    { icon: Heading3, cmd: () => exec("formatBlock", "H3"), title: "শিরোনাম ৩" },
    { icon: List, cmd: () => exec("insertUnorderedList"), title: "বুলেট তালিকা" },
    { icon: ListOrdered, cmd: () => exec("insertOrderedList"), title: "সংখ্যা তালিকা" },
    { icon: Quote, cmd: () => exec("formatBlock", "BLOCKQUOTE"), title: "উক্তি" },
    { icon: Link2, cmd: link, title: "লিংক" },
    { icon: Undo, cmd: () => exec("undo"), title: "আনডু" },
    { icon: Redo, cmd: () => exec("redo"), title: "রিডু" },
  ];

  return (
    <div className="rounded-lg border border-stone-200 overflow-hidden">
      <div className="flex flex-wrap gap-1 bg-stone-50 border-b border-stone-200 p-2">
        {btns.map((b, i) => (
          <button key={i} type="button" title={b.title} onMouseDown={(e) => { e.preventDefault(); b.cmd(); }} className="grid place-items-center h-8 w-8 rounded hover:bg-stone-200 text-stone-600">
            <b.icon className="h-4 w-4" />
          </button>
        ))}
      </div>
      <div
        ref={ref}
        contentEditable
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        className="prose prose-stone max-w-none min-h-[240px] p-4 text-sm focus:outline-none [&_h2]:font-heading [&_h2]:text-xl [&_h3]:font-heading [&_blockquote]:border-l-4 [&_blockquote]:border-[var(--c-accent)] [&_blockquote]:pl-4 [&_blockquote]:italic [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_a]:text-[var(--c-secondary)] [&_a]:underline"
      />
    </div>
  );
}
